import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common_de from "../public/static/locales/de/common.json";
import common_en from "../public/static/locales/en/common.json";
import { getLanguagePrefix } from "./utils";
export const FALLBACK_LANGUAGE = "en";
const language = getLanguagePrefix(document.URL);
const resources = {
    de: {
        common: common_de,
    },
    en: {
        common: common_en,
    },
};
i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: FALLBACK_LANGUAGE,
    ns: ["messages"],
    defaultNS: "messages",
    nsSeparator: ":", // explicitely set namespace separator since default does not work
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});
export default i18n;
